import React from 'react';
import { useState } from "react"
import SubMenu from './Tabs';
import { DrawerHeader } from '../Navigation';
import Navigation from '../Navigation';

import { dashboardData } from '../../data/dashboard';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { getUserData } from '../../repo/firebaseFunctions';
ChartJS.register(ArcElement, Tooltip, Legend);

const uid = "as";

const Dashboard = ({heading,label1,label2, label3}) => {
const userId = localStorage.getItem('uid')
const [role, setRole] = useState("Loading...");
getUserData().then(result => 
  {

    setRole(result["role"])
    localStorage.setItem("role", role)
  })


  return (
   
    <Navigation heading={role} data={dashboardData}>
       
      <Box
        sx={{
          '& > :not(style)': { m: 1 },
          right: 0,
          bottom: 0,
          position: 'absolute',
        }}
      >
        <Link to='/filter'>
        </Link>
      </Box>
      <DrawerHeader />
      <div className='container'>
        <SubMenu label1={label1} label2={label2} label3={label3}/>

        <Box
          direction='column'
          maxHeight='10vh'
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          
        </Box>
      </div>
    </Navigation>
  );
};

export default Dashboard;
